import * as React from "react";
import styled from "styled-components"
import cn from "classnames";

import { themeValues } from "../../theme";
import { SwitchSizes } from "./types";

const Handler = styled.div`
  background-color: ${themeValues.colors.white};
  border-radius: 100%;
  transition: all 0.2s ease-in-out;
`

const SwitchComponent = styled.button`
  border-radius: 50px;
  cursor: pointer;
  width: 100%;
  background-color: ${themeValues.colors.dark32};
  border: 0;
  transition: 0.2s;
  padding: 2px 2px;
  display: flex;

  &.small {
    height: 16px;
    width: 29px;

    ${Handler} {
      width: 12px;
      height: 12px;
    }
  }

  &.medium {
    height: 20px;
    width: 39px;

    ${Handler} {
      width: 16px;
      height: 16px;
    }
  }

  &[disabled] {
    cursor: not-allowed;
  }

  &.checked {
    &:not([disabled]) {
      background-color: ${themeValues.colors.blue100};
    }
    ${Handler} {
        margin-left: auto;
      }
  }

`

interface ISwitchProps {
  id?: string;
  defaultChecked: boolean;
  checked: boolean;
  disabled?: boolean;
  size?: SwitchSizes;
  onChange: (checked: boolean) => void;
}


export function Switch({ id, disabled, defaultChecked, checked, onChange, size = "medium" }: ISwitchProps): JSX.Element {
    return <SwitchComponent
    className={cn(size, disabled, { "checked": checked })}
    id={id}
    defaultChecked={defaultChecked}
    // @ts-ignore
    onChange={onChange} // TODO:
    disabled={disabled}
  >
    <Handler />
  </SwitchComponent>
}